import { Summary } from "features/shared/styles/typography/Summary.styled";
import styled from "styled-components";

interface ScannerOverlayRootProps {
  isTransparent?: boolean;
}

const ScannerOverlayRoot = styled.div<ScannerOverlayRootProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  z-index: 9001;
  background-color: ${({ isTransparent }) =>
    isTransparent ? "transparent" : "rgba(255, 255, 255, 0.95)"};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  img {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    width: 100px;
    height: 67px;
  }

  div ${Summary} {
    display: inline-block;
    margin-bottom: 0.5rem;
  }
  .bolded {
    font-weight: bold;
  }

  .doc-image-container {
    background-color: white;
    padding: 0.25rem;
  }

  .doc-image-container img {
    margin: 0;
  }
`;

export default ScannerOverlayRoot;
